import { forwardRef, useId } from 'react';
import { cn } from '../lib/cn';

export interface ToggleProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
}

/**
 * Checkbox nativo com `role="switch"`: teclado, leitor de tela e formulario
 * funcionam sem codigo. A pista e o botao sao pintados por CSS irmao.
 */
export const Toggle = forwardRef<HTMLInputElement, ToggleProps>(function Toggle(
  { className, label, id, disabled, ...props },
  ref,
) {
  const generated = useId();
  const fieldId = id ?? generated;

  return (
    <div
      className={cn('flex items-center gap-[10px]', disabled === true && 'opacity-60', className)}
    >
      <span className="relative inline-block h-6 w-11 shrink-0">
        <input
          ref={ref}
          id={fieldId}
          type="checkbox"
          role="switch"
          disabled={disabled}
          className="peer absolute inset-0 z-10 m-0 size-full cursor-pointer opacity-0 disabled:cursor-not-allowed toque:top-[-8px] toque:h-10"
          {...props}
        />
        <span
          aria-hidden="true"
          className="absolute inset-0 rounded-wc-pill bg-strong transition-colors duration-[var(--duration-micro)] peer-checked:bg-wc-blue peer-focus-visible:shadow-[var(--focus-ring)]"
        />
        <span
          aria-hidden="true"
          className="absolute top-[3px] left-[3px] size-[18px] rounded-full bg-white shadow-[0_1px_4px_rgba(0,0,0,0.15)] transition-transform duration-[var(--duration-micro)] ease-wc peer-checked:translate-x-5 motion-reduce:transition-none"
        />
      </span>
      {label !== undefined && (
        <label htmlFor={fieldId} className="cursor-pointer text-[13px] font-semibold text-primary">
          {label}
        </label>
      )}
    </div>
  );
});
